import React from 'react';
import { PayType } from '../../models/payment';
import { InfoPlate } from '../../shared/components/InfoPlate';
import './PaymentCard.css';

interface PaymentCardProps {
	type: PayType;
	selected: string;
	onSelect: (type: PayType) => void;
}

export const PaymentCard: React.FC<PaymentCardProps> = ({ type, selected, onSelect }) => {
	return (
		<div className='glass-ui'>
			<div
				className={`payment-card-container ${selected === type.id ? 'payment-card-image payment-card-selected' : ''}`}
				onClick={() => onSelect(type)}
			>
				<div className='payment-card'>
					<div className='payment-card-title'>{type.friendlyName}</div>
				</div>
				<InfoPlate>
					<div className='payment-card-price'>
						{type.price}₽
						<i className='payment-card-price-discount'>
							{type.price + (Math.round(19.5 * type.price / 100))}₽
						</i>
					</div>
				</InfoPlate>
			</div>
		</div>
	);
};